import { useState, useEffect } from "react";
import { getSenatorList, getRegions } from "../../../../api/ph-api";
import { SeoTag, CxenseParseTag } from "../../../../../components/seo/SeoTag";
import RacesPage from "../../../../../components/races/RacesPage";

export const getStaticProps = async () => {
  let regionList = await getRegions();
  let senatorialList = await getSenatorList();

  return {
    props: { senatorialList, regionList },
    revalidate: 5,
  };
};

const SenatorialPartialRes = ({ senatorialList, regionList }) => {
  const [url, setUrl] = useState("");
  const title = "PARTIAL, UNOFFICIAL: 2022 senatorial election results | Philippines";
  const description =
    "Refresh this page to see partial, unofficial, results for senator from the Comelec transparency server after polls closed on May 9, 2022. The percentage of votes received is computed based on the total number of actual voters in each contest";
  const keywords =
    "2022 Philippine elections, #PHVote, Philippine elections, , senatorial candidates philippines, election results Philippines";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords={keywords}
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <RacesPage
        view="results"
        path="senator"
        senatorialList={senatorialList}
        regionList={regionList}
        url={url}
      />
      ;
    </>
  );
};

export default SenatorialPartialRes;
